// extracted by mini-css-extract-plugin
module.exports = {"calendar":"styles-module--calendar--2yiIi","calendarMobile":"styles-module--calendarMobile--2e_rx"};